var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "receipt-container"
  }, [_c('div', {
    staticClass: "receipt-header"
  }, [_c('h3', [_vm._v("Чек №" + _vm._s(_vm.receipt.receiptId))]), _c('p', [_c('span', {
    staticClass: "receipt-date"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.receipt.createdAt, 'DD.MM.YYYY')))]), _c('span', {
    staticClass: "receipt-time"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.receipt.createdAt, 'HH:mm')) + "(Z)")])])]), _vm.isAnnulled ? _c('div', {
    staticClass: "receipt-annulled"
  }, [_c('h3', [_vm._v("Аннулирован")]), _c('p', [_vm._v("Дата: " + _vm._s(_vm._f("date")(_vm.receipt.deletedAt, 'DD.MM.YYYY')))]), _c('p', [_vm._v("Причина: " + _vm._s(_vm.receipt.reason))])]) : _vm._e(), _c('div', {
    staticClass: "receipt-user"
  }, [_vm.isOwner ? _c('div', {
    staticClass: "receipt-user-owner"
  }, [_c('p', [_vm._v(_vm._s(_vm.displayOwnerData))]), _c('p', {
    attrs: {
      "data-private": ""
    }
  }, [_vm._v("ИНН: " + _vm._s(_vm.receipt.taxPayerInn))])]) : _vm._e(), _c('div', {
    staticClass: "receipt-user-partner"
  }, [_c('p', [_vm._v("Чек сформировал: " + _vm._s(_vm.receipt.projectName))]), _c('p', {
    attrs: {
      "data-private": ""
    }
  }, [_vm._v("ИНН: " + _vm._s(_vm.receipt.partnerPlatformInn))])]), _c('div', {
    staticClass: "receipt-user-type"
  }, [_vm._v(" Режим НО: НПД ")])]), _c('div', {
    staticClass: "receipt-content"
  }, [_c('div', {
    staticClass: "receipt-content-description"
  }, [_vm._m(0), _c('p', [_vm._v(_vm._s(_vm.receipt.description))])]), _c('div', {
    staticClass: "receipt-content-amount"
  }, [_vm._m(1), _c('p', [_vm._v(_vm._s(_vm.displayReceiptAmount))])])]), _c('div', {
    staticClass: "receipt-total"
  }, [_c('div', {
    staticClass: "receipt-total-title"
  }, [_vm._v("Итого:")]), _c('div', {
    staticClass: "receipt-total-summary"
  }, [_vm._v(_vm._s(_vm.displayReceiptAmount))])]), _c('div', {
    staticClass: "receipt-code"
  }, [_c('img', {
    attrs: {
      "src": _vm.qrCode,
      "alt": ""
    }
  })])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('strong', [_vm._v("Наименование")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('strong', [_vm._v("Сумма")])]);
}]

export { render, staticRenderFns }